import Vue from 'vue';
import App404 from './404.vue';
import { startup } from '@eureka/startup';
import { loadI18n } from '../infrastructure/locales';
import { getCurrentLanguage } from '@eureka/language-tool';
import '@patsnap-ui/design-tokens/scss/_reboot.scss';
import { headerService } from '@/services/header.service';
Vue.config.productionTip = false;
startup({
    headerService,
    projectName: 'eureka',
    disableTrial: true,
    preset: {
        name: 'eureka',
    },
    pageInit: () => Promise.resolve(),
});
(async () => {
    const i18n = await loadI18n(getCurrentLanguage());
    new Vue({
        i18n,
        render: h => h(App404),
    }).$mount('#app');
})();
